export default "__VITE_ASSET__DYMn8CFc__"